import Vue from "vue";
import getLocale from "./getLocale";
import messages from "../language";
import VueI18n from "vue-i18n";
import bus from "../utils/bus.js";
Vue.use(VueI18n);


export function validationRules() {
  const i18n = new VueI18n({
    locale: getLocale(), // set locale
    messages // set locale messages
  }); 

  // Check current SITE
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookies = decodedCookie.split(";");
  const name = "SiteSettings";
  let site = "cibc";
  for (let c of cookies) {
      while (c.charAt(0) === " ") {
          c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
          site = c.substring(13);
      }
  }
  if(site==="cibcinsurance"){
    site="nm";
  }
  else {
    site="";
  }
  

  return {
    // Page 3 fields
    oldestTraveller_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')      
    },
    departureDate: {
      type: "date",
      required: true,
      errorcode: '1002',
      requirederror: i18n.t('text.invalid_departureDate')
    },
    returnDate: {
      type: "date",
      required: true,
      errorcode: '1003',
      requirederror: i18n.t('text.invalid_returnDate')
    },
    province: {
      type: "select",
      required: true,
      errorcode: '1013',
      requirederror: i18n.t('text.invalid_province')
    },
    tripCost:{
      type: "select",
      required: false,
      requirediffield: "wantsCancellation",
      requiredifvalue: true,
      errorcode: '1026',
      requirederror : i18n.t('text.invalid_tripCostRequired')
    },

    // Page 4 fields
    mq1y: {
      type: "radio",
      required: false,
      oneofgroup: true
    },
    mq2y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq3y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq4y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq5y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq6y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq7y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq8y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq9y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq10y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq11y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq12y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq13y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq14y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq15y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq16y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq17y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq18y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq19y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq20y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq21y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq22y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq23y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq24y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    mq25y: {
      type: "radio",
      required: true,
      oneofgroup: true,
    },
    confirmMedical: {
      type: "checkbox",
      required: true,
      errorcode: '1024',
      requirederror: i18n.t('text.invalid_terms'),
    },

    // Page 9 fields
    cn1y: {
      type: "radio",
      required: true,
      errorcode: '1008',
      requirederror: i18n.t('text.invalid_confirmNotice') 
    },
    confirmWhatsNotCovered: {
      type: "checkbox",
      required: true,
      errorcode: '1008',
      requirederror: i18n.t('text.invalid_confirmWhatsNotCovered'),
    },
    confirmPrivacyPolicy: {
      type: "checkbox",
      required: true,
      errorcode: '1008',
      requirederror: i18n.t('text.invalid_confirmPrivacyPolicy'),
    },

    // Page 10 Fields
    tripStart: {
      type: "date",
      required: true,
      errorcode: '1017',
      requirederror: i18n.t('text.invalid_coverageStartDate')
    },   
    traveller1_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller1_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller1_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    address1: {
      type: "string",
      required: true,
      shareerror: 'address2',
      errorcode: '1011',
      requirederror: i18n.t('text.invalid_address') 
    },
    address2: {
      type: "string",
      required: false,
      requirediffield: 'address1',
      requiredifvalue: ''
    },
    city: {
      type: "string",
      required: true,
      errorcode: '1012',
      requirederror: i18n.t('text.invalid_city')
    },
    postalcode: {
      type: "postalcode",
      required: true,
      errorcode: '1014',
      requirederror: i18n.t('text.invalid_postalcode'),
      minlength:6
    },
    phone: {
      type: "phone",
      required: true,
      errorcode: '1015',
      requirederror: i18n.t('text.invalid_phone')
    },
    /*email: {
      type: "email",
      required: true,
      requirederror: i18n.t('text.invalid_email')
    },*/

    // Page 11 fields
    traveller2_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller2_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller2_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller3_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller3_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller3_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller4_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller4_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller4_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller5_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller5_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller5_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller6_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller6_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller6_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller7_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller7_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller7_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller8_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller8_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller8_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller9_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller9_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller9_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    traveller10_firstname: {
      type: "string",
      required: true,
      errorcode: '1009',
      requirederror: i18n.t('text.invalid_firstname')
    },
    traveller10_lastname: {
      type: "string",
      required: true,
      errorcode: '1010',
      requirederror: i18n.t('text.invalid_lastname')
    },
    traveller10_dob: {
      type: "date",
      required: true,
      errorcode: '1005',
      requirederror: i18n.t('text.invalid_dobempty')
    },
    // Page 12 fields
    creditcard: {
      type: "string",
      required: true,
      errorcode: '1020',
      requirederror: i18n.t('text.invalid_creditcard'),
      minlength: 16
    },
    creditcard_name: {
      type: "string",
      required: true,
      errorcode: '1021',
      requirederror: i18n.t('text.invalid_creditcardname'),
    },
    expiration: {
      type: "expiry",
      required: true,
      errorcode: '1022',
      requirederror: i18n.t('text.invalid_expiration'),
      minlength: 4
    },
    creditcard_cvv: {
      type: "string",
      required: true,
      errorcode: '1023',
      requirederror: i18n.t('text.invalid_cvv'),
      minlength:3
    },
    confirmTerms: {
      type: "checkbox",
      required: true,
      errorcode: '1024',
      requirederror: i18n.t('text.invalid_terms'),
    },
    confirmTermsPrivacyPolicy: {
      type: "checkbox",
      required: true,
      errorcode: '1024',
      requirederror: i18n.t('text.invalid_termsPrivacyPolicy'),
    },
  };
}